import React from 'react';
import classNames from 'classnames';

interface OnboardingContentWrapperProps {
  children: React.ReactNode;
  className?: string;
  withShadow?: boolean;
}

const OnboardingContentWrapper: React.FC<OnboardingContentWrapperProps> = ({ 
  children, 
  className,
  withShadow = true
}) => {
  return (
    <div 
      className={classNames(
        'bg-white bg-opacity-95 backdrop-blur-sm rounded-xl py-8 px-4',
        withShadow && 'shadow-lg shadow-indigo-900/5',
        'border border-indigo-50',
        className
      )}
    >
      {children}
    </div>
  );
};

export default OnboardingContentWrapper; 